import { type EntryComponentProps } from '@draft-js-plugins/mention/lib/MentionSuggestions/Entry/Entry'

export const EntryComponent = ({
  mention,
  isFocused,
  selectMention,
  searchValue,
  theme,
  ...parentProps
}: EntryComponentProps) => {
  return (
    <div
      className="text-sm cursor-pointer text-grey-800"
      {...parentProps}
    >
      <span className="font-normal">@{mention.name}</span>
      <span className="inline-block mx-2 text-grey-500">|</span>
      <span className="text-xs text-grey-500">
        {mention.email}
      </span>
    </div>
  )
}
